import { StringHelpers } from '../helpers/stringHelpers';

export const Categories = [
  'tech-for-good',
  'cyber',
  'fintech',
  'medtech',
  'creative',
  'media',
  'gaming',
  'immersive',
  'greentech',
  'deep-tech',
  'telecoms',
  'ai',
  'data',
  'hardware',
  'robotics',
  'digital',
  'edtech',
  'saas',
  'all',
] as const;

export const SeedLevels = ['Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C', 'Unknown'] as const;

export const seedRangeOutput = (seedLevel) => {
  if (seedLevel === 'Unknown') {
    return '£0 - £?';
  }
  if (seedLevel === 'Pre-Seed') {
    return '£5k - £150k';
  }
  if (seedLevel === 'Seed') {
    return '£151k - £1m';
  }
  if (seedLevel === 'Series A') {
    return '£1m - £4m';
  }
  if (seedLevel === 'Series B') {
    return '£4m - £10m';
  }
  if (seedLevel === 'Series C') {
    return '£10m+';
  }
};

export type CategoryTuple = typeof Categories;
export type Category = CategoryTuple[number];
export type SeedLevelTuple = typeof SeedLevels;
export type SeedLevel = SeedLevelTuple[number];

export interface ILocation {
  index: number;
  name: string;
  description?: string;
  city: string;
  postcode: string;
  category: Category;
  location: number[];
  webUrl: string;
  twitterUrl: string;
  investment: string;
  featured: string;
}

export const parseCategory = (cat: string): Category => {
  switch (cat) {
    case 'Tech For Good':
      return 'tech-for-good';
    case 'Medtech/Biotech':
      return 'medtech';
    case 'Deeptech':
      return 'deep-tech';
    default:
      return cat.toLowerCase().replace(/\//g, '-').replace(/\s+/g, '-') as Category;
  }
};

export const getFriendlyCategoryName = (cat: Category): string => {
  switch (cat) {
    case 'medtech':
      return 'MEDTECH/BIOTECH';
    case 'tech-for-good':
      return 'TECH FOR GOOD';
    case 'deep-tech':
      return 'DEEP TECH';
    default:
      return StringHelpers.slugToSentence(StringHelpers.toUpper(cat));
  }
};

export const getFriendlySeedLevelName = (seedLevel: SeedLevel): string => {
  return StringHelpers.slugToSentence(StringHelpers.toUpper(seedLevel));
};
